<template>
  <div class="main" v-title data-title="北京天蔚中医药发展促进中心-公司动态">
    <div class="swipe">
      <img src="http://123.56.170.62:9999/static/bg/banner3.png" alt />
    </div>
    <Class :nav="nav"></Class>
  </div>
</template>
<script>
import Class from "@/components/Class.vue"
import Bus from "@/utils/bus.js"
export default {
  data() {
    return {
      nav: [
        { title: "行业动态", url: "hydt" },
        { title: "机构动态", url: "jgdt" },
        { title: "项目动态", url: "xmdt" },
        { title: "活动展示", url: "hdzs" },
      ],
    }
  },
  mounted() {
    this.$nextTick(function() {
      Bus.$emit("getCurrent", "news")
    })
  },
  methods: {},
  components: {
    Class,
  },
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  .swipe {
    width: 100%;
    img {
      width: 100%;
      height: 400px;
    }
  }
}
</style>
